export default __webpack_public_path__ + "static/media/back.f22789b9.svg";